//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSupplierInfoApi, updateSupplierInfoApi, getSupplierQrcodeApi } from '@/api/supplier';
export default {
  name: 'SupplierQrcode',
  data: function data() {
    var validateDiscount = function validateDiscount(rule, value, callback) {
      if (!value || value === '') {
        callback();
        return;
      }
      var num = parseFloat(value);
      if (isNaN(num) || num <= 0 || num > 1) {
        callback(new Error('折扣率请填写 0~1 之间的数值，如 0.9'));
      } else {
        callback();
      }
    };
    return {
      supplierInfo: {},
      infoLoading: false,
      qrcodeUrl: '',
      qrcodeLoading: false,
      saving: false,
      form: {
        discountRate: ''
      },
      rules: {
        discountRate: [{
          validator: validateDiscount,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    discountText: function discountText() {
      var rate = parseFloat(this.form.discountRate);
      if (!rate || rate <= 0 || rate >= 1) return '';
      var text = (rate * 10).toFixed(1).replace('.0', '');
      return text + '折';
    }
  },
  mounted: function mounted() {
    this.loadInfo();
    this.loadQrcode();
  },
  methods: {
    loadInfo: function loadInfo() {
      var _this = this;
      this.infoLoading = true;
      getSupplierInfoApi().then(function (res) {
        _this.supplierInfo = res || {};
        _this.form.discountRate = res && res.discountRate ? String(res.discountRate) : '';
      }).catch(function () {}).finally(function () {
        _this.infoLoading = false;
      });
    },
    loadQrcode: function loadQrcode() {
      var _this2 = this;
      this.qrcodeLoading = true;
      this.qrcodeUrl = '';
      getSupplierQrcodeApi().then(function (res) {
        if (res && res.image) {
          _this2.qrcodeUrl = res.image;
        } else if (res && typeof res === 'string') {
          _this2.qrcodeUrl = res;
        } else if (res && res.code && typeof res.code === 'string') {
          // 后端返回结构：{ code: 'data:image/png;base64,...', message: null }
          _this2.qrcodeUrl = res.code;
        }
      }).catch(function () {
        _this2.$message.error('二维码获取失败');
      }).finally(function () {
        _this2.qrcodeLoading = false;
      });
    },
    downloadQrcode: function downloadQrcode() {
      if (!this.qrcodeUrl) return;
      var link = document.createElement('a');
      link.href = this.qrcodeUrl;
      link.download = '供应商码.jpg';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    saveDiscount: function saveDiscount() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this3.saving = true;
        var data = {
          discountRate: _this3.form.discountRate ? parseFloat(_this3.form.discountRate) : null
        };
        updateSupplierInfoApi(data).then(function () {
          _this3.$message.success('保存成功');
          _this3.loadInfo();
        }).catch(function () {}).finally(function () {
          _this3.saving = false;
        });
      });
    },
    resetForm: function resetForm() {
      this.form.discountRate = this.supplierInfo.discountRate ? String(this.supplierInfo.discountRate) : '';
      this.$refs.form.clearValidate();
    }
  }
};